import { useEffect, useState, lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// Shared Components (NO LAZY - always needed) //
import Header from "./Component/Shared/Header";
import Footer from "./Component/Shared/Footer";
import Menu from "./Component/Shared/Menu";
import EnquiryForm from "./Component/Shared/EnquiryForm";

// Lazy Loaded Pages //
// Pages
const Home = lazy(() => import("./Component/Pages/Home"));
const AboutUs = lazy(() => import("./Component/Pages/AboutUs"));
const Clients = lazy(() => import("./Component/Pages/Clients"));
const Careers = lazy(() => import("./Component/Pages/Careers"));
const ContactUs = lazy(() => import("./Component/Pages/ContactUs"));
const Services = lazy(() => import("./Component/Pages/services/Services"));
// const SearchByLocation = lazy(() => import("./Component/Pages/Search-By-Location"));
const Corporate_video_production_company_in_mumbai = lazy(() => import("./Component/Pages/Corporate-video-production-company-in-mumbai"));

// Services
const WebService = lazy(() => import("./Component/Pages/services/WebService"));
const FilmsService = lazy(() => import("./Component/Pages/services/FilmsService"));
const DigitalMarketingServices = lazy(() =>
  import("./Component/Pages/services/DigitalMarketingServices"));
const CreativeServices = lazy(() => import("./Component/Pages/services/CreativeServices"));
const DigitalActivationServices = lazy(() =>
  import("./Component/Pages/services/DigitalActivationServices"));
const Photography = lazy(() => import("./Component/Pages/services/Photography"));

// Static pages
const Sitemap = lazy(() => import("./Component/Pages/Sitemap"));
const PrivacyPolicy = lazy(() => import("./Component/Pages/PrivacyPolicy"));
const Faq = lazy(() => import("./Component/Pages/Faq"));
const TermsOfUse = lazy(() => import("./Component/Pages/TermsOfUse"));

// =====================
// Work Pages (lazy)
// =====================
const ElleysElectrics = lazy(() => import("./Component/Pages/work/Website/ElleysElectrics"));
const Memoria = lazy(() => import("./Component/Pages/work/Memoria"));
const WelspunGroup = lazy(() => import("./Component/Pages/work/video_production/WelspunGroup"));
const WelspunCSR = lazy(() => import("./Component/Pages/work/video_production/WelspunCSR"));
const ICICIPrudential = lazy(() => import("./Component/Pages/work/ICICIPrudential"));
const OurWork = lazy(() => import("./Component/Pages/OurWork"));
const WelspunBKG = lazy(() => import("./Component/Pages/work/video_production/WelpsunBKG"));
const Notandas = lazy(() => import("./Component/Pages/work/Website/Notandas"));
const Vardhman = lazy(() => import("./Component/Pages/work/Website/Vardhman"));

const IndusInd = lazy(() => import("./Component/Pages/work/digital_marketing/IndusInd"));
const AdvanceSolution = lazy(() => import("./Component/Pages/work/digital_marketing/AdvanceSolution"));
const IciciPensionFund = lazy(() => import("./Component/Pages/work/digital_marketing/IciciPensionFund"));
const IciciPrudential = lazy(() => import("./Component/Pages/work/digital_marketing/IciciPrudential"));
const JindalSAW = lazy(() => import("./Component/Pages/work/digital_marketing/JindalSAW"));
const OneGamingArcade = lazy(() => import("./Component/Pages/work/digital_marketing/OneGamingArcade"));
const PatelUrologyHospital = lazy(() => import("./Component/Pages/work/digital_marketing/PatelUrologyHospital"));
const Mpuh2 = lazy(() => import("./Component/Pages/work/digital_marketing/Mpuh2"));
const ICICI_Creatives = lazy(() => import("./Component/Pages/work/digital_marketing/ICICI_Creatives"));
const SkyGreens = lazy(() => import("./Component/Pages/work/digital_marketing/SkyGreens"));
const SpeedOfSound = lazy(() => import("./Component/Pages/work/digital_marketing/SpeedOfSound"));
const Tiger = lazy(() => import("./Component/Pages/work/digital_marketing/Tiger"));
const Sunpharma = lazy(() => import("./Component/Pages/work/digital_marketing/Sunpharma"));
const Dabur = lazy(() => import("./Component/Pages/work/digital_marketing/Dabur"));

// Digital Activation
const McDowellNo1 = lazy(() => import("./Component/Pages/work/digital_activation/McDowellNo1"));
const AlkemArFilters = lazy(() => import("./Component/Pages/work/digital_activation/AlkemArFilters"));
const AmazonSambav = lazy(() => import("./Component/Pages/work/digital_activation/AmazonSambhav"));
const LorealMatrix = lazy(() => import("./Component/Pages/work/digital_activation/LorealMatrix"));



// Video Production
const AlkemLaboratories = lazy(() => import("./Component/Pages/work/video_production/AlkemLaboratories"));
const CanadianWoods = lazy(() => import("./Component/Pages/work/video_production/CanadianWoods"));
const DHCInternationalTeaser = lazy(() => import("./Component/Pages/work/video_production/DHCInternationalTeaser"));
const DodhiaCorporateFilm = lazy(() => import("./Component/Pages/work/video_production/DodhiaCorporateFilm"));
const DodhiaTextiles = lazy(() => import("./Component/Pages/work/video_production/DodhiaTextiles"));
const DoradoIvory = lazy(() => import("./Component/Pages/work/video_production/DoradoIvory"));
const ISolus = lazy(() => import("./Component/Pages/work/video_production/ISolus"));
const JesonsTechCentre = lazy(() => import("./Component/Pages/work/video_production/JesonsTechCentre"));
const KukuFm = lazy(() => import("./Component/Pages/work/video_production/KukuFm"));
const NeoNiche = lazy(() => import("./Component/Pages/work/video_production/NeoNiche"));
const QR678 = lazy(() => import("./Component/Pages/work/video_production/QR678"));
const Recipe = lazy(() => import("./Component/Pages/work/video_production/Recipe"));
const RockmanIndustries = lazy(() => import("./Component/Pages/work/video_production/RockmanIndustries"));
const SpeakEvent = lazy(() => import("./Component/Pages/work/video_production/SpeakEvent"));
const SpeakHealth = lazy(() => import("./Component/Pages/work/video_production/SpeakHealth"));
const VijaySales = lazy(() => import("./Component/Pages/work/video_production/VijaySales"));

// Creative Design
const RsblCalendar = lazy(() => import("./Component/Pages/work/creative_design/RsblCalendar"));
const RsblCalendar2025 = lazy(() => import("./Component/Pages/work/creative_design/RsblCalendar2025"));
const AymSyntexAnnualReport = lazy(() => import("./Component/Pages/work/creative_design/AymSyntexAnnualReport"));
const CreativeMemoria = lazy(() => import("./Component/Pages/work/creative_design/Memoria"));
const DodhiaStall = lazy(() => import("./Component/Pages/work/creative_design/DodhiaStallDesign"));
const AymSyntexBrochure = lazy(() => import("./Component/Pages/work/creative_design/AymSyntaxBrochure"));
const AymLeafLets = lazy(() => import("./Component/Pages/work/creative_design/AymLeafLets"));
const LjmLogo = lazy(() => import("./Component/Pages/work/creative_design/LjmLogo"));
const AymStallDesign = lazy(() => import("./Component/Pages/work/creative_design/AymStallDesign"));
const TataCsrReport = lazy(() => import("./Component/Pages/work/creative_design/TataCsrReport"));

// Other works
const DodhiaWeb = lazy(() => import("./Component/Pages/work/Website/DodhiaWebsite"));
const BhsWeb = lazy(() => import("./Component/Pages/work/Website/BhsWeb"));
const Digisuraksha = lazy(() => import("./Component/Pages/work/Website/Digisuraksha"));
const Solstice = lazy(() => import("./Component/Pages/work/Website/Solstice"));
const Jcb = lazy(() => import("./Component/Pages/work/Website/jcb"));
const KhalidaToukkani = lazy(() => import("./Component/Pages/work/Website/KhalidaToukkani"));

const IciciPrundentialLifeInsurance = lazy(() => import("./Component/Pages/work/video_production/IciciPrudentialLifeInsurance"));
const Vardhmaan = lazy(() => import("./Component/Pages/work/video_production/Vardhman"));
const RockmanAdvancedComp = lazy(() => import("./Component/Pages/work/video_production/RockmanAdvancedComp"));
const RockmanValuesFilm = lazy(() => import("./Component/Pages/work/video_production/RockmanValuesFilm"));
const SpeakHealthDigital = lazy(() => import("./Component/Pages/work/digital_marketing/SpeakHealth"));
const VijaySales2 = lazy(() => import("./Component/Pages/work/video_production/VijaySales2"));
const DodhiaChemicals = lazy(() => import("./Component/Pages/work/video_production/DodhiaChemicals"));
const Welpsun = lazy(() => import("./Component/Pages/work/Website/Welpsun"));
const AymSyntex = lazy(() => import("./Component/Pages/work/Website/AymSyntex"));
const ContinuumIndia = lazy(() => import("./Component/Pages/work/Website/ContinuumIndia"));
const Goodricke = lazy(() => import("./Component/Pages/work/Website/Goodricke"));
const Grays256 = lazy(() => import("./Component/Pages/work/Website/Grays256"));
const Bizdesign = lazy(() => import("./Component/Pages/work/Website/Bizdesign"));
const Local2030 = lazy(() => import("./Component/Pages/work/Website/Local2030"));
const MalikArchitecture = lazy(() => import("./Component/Pages/work/Website/MalikArchitecture"));
const NagarkotLogistics = lazy(() => import("./Component/Pages/work/Website/NagarkotLogistics"));
const Texprocile = lazy(() => import("./Component/Pages/work/Website/Texprocile"));
const Commercial = lazy(() => import("./Component/Pages/work/photography/Commercial"));
const Commercial2 = lazy(() => import("./Component/Pages/work/photography/Markhome"));
const AllProjects = lazy(() => import("./Component/Shared/OurWork/AllProjects"));
const WebsiteApp2 = lazy(() => import("./Component/Shared/OurWork/WebsiteApp"));
const VideoProduction2 = lazy(() => import("./Component/Shared/OurWork/VideoProduction"));
const CreativeDesign2 = lazy(() => import("./Component/Shared/OurWork/CreativeDesign"));
const DigitalActivation2 = lazy(() => import("./Component/Shared/OurWork/DigitalActivation"));
const DigitalMarketing2 = lazy(() => import("./Component/Shared/OurWork/DigitalMarketing"));
const Photography2 = lazy(() => import("./Component/Shared/OurWork/Photography"));
const WelpsunGroupCorpFilm = lazy(() => import("./Component/Pages/work/video_production/WelpsunGroupCorpFilm"));
const DHCInternational = lazy(() => import("./Component/Pages/work/video_production/DHCInternational"));
const Konvertors = lazy(() => import("./Component/Pages/work/photography/Konvertors"));
const Pankhudiyan = lazy(() => import("./Component/Pages/work/video_production/Pankhudiyan"));
const SugnaStone = lazy(() => import("./Component/Pages/work/video_production/SugnaStone"));
const Tecnik = lazy(() => import("./Component/Pages/work/video_production/Tecnik"));
const AnandCorporate = lazy(() => import("./Component/Pages/work/video_production/AnandCorporate"));

const LagataCorporate = lazy(() => import("./Component/Pages/work/video_production/LagataCorporate"));
const Makoons = lazy(() => import("./Component/Pages/work/digital_marketing/Makoons"));
const ITTSocial = lazy(() => import("./Component/Pages/work/digital_marketing/ITTSocial"));
const KotakFestival = lazy(() => import("./Component/Pages/work/digital_marketing/KotakFestival"));
const DodhiaSocial = lazy(() => import("./Component/Pages/work/digital_marketing/DodhiaSocial"));
const BHS_Social = lazy(() => import("./Component/Pages/work/digital_marketing/Bhs_social"));
const IciciVideo = lazy(() => import("./Component/Pages/work/video_production/IciciVideo"));
const BoroPlusHealthySkin = lazy(() => import("./Component/Pages/work/Website/BoroPlusHealthySkin"));
const Golcha = lazy(() => import("./Component/Pages/work/video_production/Golcha"));
const Abacus = lazy(() => import("./Component/Pages/work/video_production/Abacus"));


// import Blogs from "./Component/Pages/Blogs";


// App Component //

function App() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isCursorOver, setIsCursorOver] = useState(false);
  const [isCursorOverBlack, setIsCursorOverBlack] = useState(false);
  const [isCursorOverRed, setIsCursorOverRed] = useState(false);
  const [isCursorOverFooter, setIsCursorOverFooter] = useState(false);
  const [isCursorOverRedSmall, setIsCursorOverRedSmall] = useState(false);

  useEffect(() => {
    const updatePosition = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    document.addEventListener("mousemove", updatePosition);
    return () => document.removeEventListener("mousemove", updatePosition);
  }, []);

  // ===== FIXED HANDLERS (IMPORTANT) =====
  const handleMouseEnter = () => setIsCursorOver(true);
  const handleMouseLeave = () => setIsCursorOver(false);

  const handleMouseEnterBlack = () => setIsCursorOverBlack(true);
  const handleMouseLeaveBlack = () => setIsCursorOverBlack(false);

  const handleMouseEnterRed = () => setIsCursorOverRed(true);
  const handleMouseLeaveRed = () => setIsCursorOverRed(false);

  const handleMouseEnterFooter = () => setIsCursorOverFooter(true);
  const handleMouseLeaveFooter = () => setIsCursorOverFooter(false);

  const handleMouseEnterRedSmall = () => setIsCursorOverRedSmall(true);
  const handleMouseLeaveRedSmall = () => setIsCursorOverRedSmall(false);

  return (
    <main>
      <div
        className={`custom-cursor ${
          isCursorOver
            ? "active"
            : isCursorOverFooter
            ? "active white"
            : isCursorOverRed
            ? "white-Cursor"
            : isCursorOverRedSmall
            ? "active_small"
            : "normal_cursor"
        }`}
        style={{ left: position.x, top: position.y }} />

        {/* </div> */}
        {/* // style={{ left: `${position.x}px`, top: `${position.y}px` }} */}

      <HelmetProvider>
        <BrowserRouter>
          <Header />
          <EnquiryForm 
            mouseEnterOnRed={handleMouseEnterRed}
            mouseLeaveOnRed={handleMouseLeaveRed}
            />
          <Menu
            mouseEnterOnRed={handleMouseEnterRed}
            mouseLeaveOnRed={handleMouseLeaveRed}
            mouseEnterOnBlack={handleMouseEnterBlack}
            mouseLeaveOnBlack={handleMouseLeaveBlack}
            mouseEnterOnFooter={handleMouseEnterFooter}
            mouseLeaveOnFooter={handleMouseLeaveFooter}
          />

    {/* 🔥 LAZY LOADING WRAPPER */}
    <Suspense fallback={<div style={{ padding: "100px" }}>Loading...</div>}>
        <Routes>
            
            <Route path="*" element={<Home
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            />} />

            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact-us" element={<ContactUs />} />

            {/* <Route path="/search-by-location" element={<SearchByLocation />} /> */}
            <Route path="/corporate-video-production-company-in-mumbai"
                element={<Corporate_video_production_company_in_mumbai />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />

            <Route path="/website-and-mobile/" element={<WebService />} />
            <Route path="/video-production/" element={<FilmsService />} />
            <Route path="/digital-marketing/" element={<DigitalMarketingServices />} />
            <Route path="/Creative-Services" element={<CreativeServices />} />
            <Route path="/Digital-Activation-Services" element={<DigitalActivationServices />} />
            <Route path="/still-photography/" element={<Photography />} />

            <Route path="/works" element={<OurWork
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  mouseEnterOnBlack={handleMouseEnterBlack}
                  mouseLeaveOnBlack={handleMouseLeaveBlack}
                />} />
            
            <Route path="/alkemlaboratories" element={<AlkemLaboratories />} />
            <Route path="/canadian-woods" element={<CanadianWoods />} />
            <Route path="/dodhia-corporate-film" element={<DodhiaCorporateFilm />} />
            <Route path="/dodhia-textiles" element={<DodhiaTextiles />} />
            <Route path="/dorado-ivory" element={<DoradoIvory />} />
            <Route path="/isolus" element={<ISolus />} />
            <Route path="/kukufm" element={<KukuFm />} />
            <Route path="/neo-niche" element={<NeoNiche />} />
            <Route path="/qr678" element={<QR678 />} />
            <Route path="/recipe" element={<Recipe />} />
            <Route path="/rockman-industries" element={<RockmanIndustries />} />
            <Route path="/speak-event" element={<SpeakEvent />} />
            <Route path="/speak-health" element={<SpeakHealth />} />
            <Route path="/vijay-sales" element={<VijaySales />} />

            <Route path="/rsbl-calendar" element={<RsblCalendar />} />
            <Route path="/rsbl-calendar_2025" element={<RsblCalendar2025 />} />
            <Route path="/aym-syntex-annual-report" element={<AymSyntexAnnualReport />} />
            <Route path="/creative-memoria" element={<CreativeMemoria />} />

            <Route path="/dodhiaweb" element={<DodhiaWeb />} />
            <Route path="/bhsweb" element={<BhsWeb />} />
            <Route path="/digisuraksha" element={<Digisuraksha />} />
            <Route path="/solstice" element={<Solstice />} />
            <Route path="/jcb" element={<Jcb />} />
            <Route path="/KhalidaToukkani" element={<KhalidaToukkani />} />
            <Route path="/notandas" element={<Notandas />} />
            <Route path="/vardhman" element={<Vardhman />} />
            <Route path="/welspun" element={<Welpsun />} />
            <Route path="/works/all-projects" element={<AllProjects />} />
            <Route path="/works/photography" element={<Photography2 />} />
            <Route path="/works/website-app" element={<WebsiteApp2 />} />
            <Route path="/works/video-production" element={<VideoProduction2 />} />
            <Route path="/works/digital-activation" element={<DigitalActivation2 />} />
            <Route path="/works/digital-marketing" element={<DigitalMarketing2 />} />
            <Route path="/works/creative-design" element={<CreativeDesign2 />} />
            <Route path="/konvertors" element={<Konvertors />} />          
            <Route path="/DHCinternational" element={<DHCInternational />} /> 
            <Route path="/dodhiastall" element={<DodhiaStall />} />
            <Route path="/DHCinternational-teaser" element={<DHCInternationalTeaser />} />
            <Route path="/dodhiachemicals" element={<DodhiaChemicals />} />
            <Route path="/tatacsr-report" element={<TataCsrReport />} />
            <Route path="/aymstall-design" element={<AymStallDesign />} />
            <Route path="/ljmlogo" element={<LjmLogo />} />
            <Route path="/aymleaflets" element={<AymLeafLets />} />
            <Route path="/icici-prundential-life-insurance" element={<IciciPrundentialLifeInsurance />} />
            <Route path="/jesons-tech-centre" element={<JesonsTechCentre />} />
            <Route path="/rockman-advance-comp" element={<RockmanAdvancedComp />} />
            <Route path="/rockman-values-film" element={<RockmanValuesFilm />} />
            <Route path="/speak-health2" element={<SpeakHealthDigital />} />          
            <Route path="/pankhudiyan" element={<Pankhudiyan />} />
            <Route path="/sugna-stone" element={<SugnaStone />} />
            <Route path="/icici-video" element={<IciciVideo />} />
            <Route path="/anand-corporate" element={<AnandCorporate />} />
            <Route path="/tecnik" element={<Tecnik />} />
            <Route path="/lagata-corporate" element={<LagataCorporate />} />
            <Route path="/vijay-sales2" element={<VijaySales2 />} />
            <Route path="/aym-syntex-brochure" element={<AymSyntexBrochure />} />         
            <Route path="/vardhman" element={<Vardhman />} />
            <Route path="/vardhman2" element={<Vardhmaan />} />
            <Route path="/aym-syntex" element={<AymSyntex />} />
            <Route path="/continuum-india" element={<ContinuumIndia />} />
            <Route path="/goodricke" element={<Goodricke />} />
            <Route path="/256grays" element={<Grays256 />} />
            <Route path="/Bizdesign" element={<Bizdesign />} />
            <Route path="/local2030" element={<Local2030 />} />
            <Route path="/malik-architecture" element={<MalikArchitecture />} />
            <Route path="/nagarkot-logistics" element={<NagarkotLogistics />} />
            <Route path="/texprocil" element={<Texprocile />} />
            <Route path="/dabur" element={<Dabur />} />
            <Route path="/speed-of-sound" element={<SpeedOfSound />} />
            <Route path="/sunpharma" element={<Sunpharma />} />
            <Route path="/advance-solution" element={<AdvanceSolution />} />
            <Route path="/icici-pension-fund" element={<IciciPensionFund />} />
            <Route path="/icici-prudential" element={<IciciPrudential />} />
            <Route path="/jindal-SAW" element={<JindalSAW />} />
            <Route path="/one-gaming-arcade" element={<OneGamingArcade />} />
            <Route path="/mpuh2" element={<Mpuh2 />} />
            <Route path="/mpuh" element={<PatelUrologyHospital />} />
            <Route path="/ICICI_Creatives" element={<ICICI_Creatives />} />
            <Route path="/sky-greens" element={<SkyGreens />} />
            <Route path="/makoons" element={<Makoons />} />
            <Route path="/itt_social" element={<ITTSocial />} />
            <Route path="/dodhia_social" element={<DodhiaSocial />} />
            <Route path="Bhs_social" element={<BHS_Social />} />
            <Route path="/kotak_festival"   element={<KotakFestival />} />
            <Route path="/tiger"   element={<Tiger />} />
            <Route path="/indusind"   element={<IndusInd />} />
            <Route path="/elleyselectrics" element={<ElleysElectrics />} />
            <Route path="/Memoria" element={<Memoria />} />
            <Route path="/welspunGroup" element={<WelspunGroup />} />
            <Route path="/welspunCSR" element={<WelspunCSR />} />
            <Route path="/welpsunGroupCorpFilm" element={<WelpsunGroupCorpFilm />} />
            <Route path="/welspunBKG" element={<WelspunBKG/>} />
            <Route path="/iciciprudential" element={<ICICIPrudential />} />
            <Route path="/mcdowell" element={<McDowellNo1 />} />
            <Route path="/alkem-ar-filters" element={<AlkemArFilters />} />
            <Route path="/amazon-sambhav" element={<AmazonSambav />} />
            <Route path="/markhome-photography2024" element={<Commercial />} />
            <Route path="/Markhome" element={<Commercial2 />} />
            <Route path="/loreal-matrix" element={<LorealMatrix />} />
            <Route path="/boro-plus-healthy-skin" element={<BoroPlusHealthySkin />} />
            <Route path="/golcha" element={<Golcha />} />
            <Route path="/abacus" element={<Abacus />} />

            
        </Routes>
    </Suspense>
        <Footer
            mouseEnterOnRed={handleMouseEnterRed}
            mouseLeaveOnRed={handleMouseLeaveRed}
            mouseEnterOnBlack={handleMouseEnterBlack}
            mouseLeaveOnBlack={handleMouseLeaveBlack}
            mouseEnterOnFooter={handleMouseEnterFooter}
            mouseLeaveOnFooter={handleMouseLeaveFooter}
          />
        </BrowserRouter>
      </HelmetProvider>
    </main>
  );
}

export default App;